module.exports = __webpack_public_path__ + "static/img/carbon_dioxide.869bce19.png";